var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('v-btn',{staticClass:"button-base",attrs:{"depressed":"","color":"primary","loading":_vm.isLoading},on:{"click":_vm.clickHandler}},[_vm._v("Предоставить дополнительные документы ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }